import React, { useState, useEffect } from 'react';
import { useTimer } from 'react-timer-hook';
import { useNavigate } from 'react-router-dom'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import FileCopyIcon from '@mui/icons-material/FileCopyRounded';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Paper from '@mui/material/Paper';
import ContentPasteIcon from '@mui/icons-material/ContentPasteRounded';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearchRounded';
import { formatDate } from '../../../helpers'
import { colors } from '../../../settings'
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import LinearProgress from '@mui/material/LinearProgress';
import Chip from '@mui/material/Chip';

export default function FeedsTable(props) {
    const navigate = useNavigate()
        
    const {totalSeconds} = useTimer({
        expiryTimestamp: new Date(new Date().getTime() + 100000000)
    })

    const loadedTime = (loadedAt) => {
        if (!loadedAt) {
            return 'Never'
        }
        
        const ld = new Date(loadedAt).getTime() / 1000 / 60
        const now = new Date().getTime() / 1000 / 60
        const d = 10 - (now - ld) + 1
        
        if (d >= 0) {
            return Math.floor(d) + 'm'
        } else
        if (d > -60) {
            return (
                <div style={{color:'red'}}>{Math.floor(-d) + 'm late'}</div>
            )
        } else {
            return (
                <div style={{color:'red'}}>{Math.floor(-d / 60) + 'h late'}</div>
            )
        }
        
    }
    
    const progressValue = (val) => {
        const a = val.split(':')
        const curr = parseInt(a[0]) ?? 0
        const max = parseInt(a[1]) ?? 0
        return max > 0 ? curr * 100 / max : 0
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" sx={{ width: 400 }}>Name</TableCell>
                        <TableCell align="center" sx={{ width: 80 }}>Status</TableCell>
                        <TableCell align="center" sx={{ width: 90 }}>Next Try</TableCell>
                        <TableCell align="center" sx={{ width: 100 }}>Processed</TableCell>
                        <TableCell align="center" sx={{ width: 40 }}>Actions</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.items?.map((row) => (
                        <TableRow
                            hover
                            key={row.id}
                            sx={{ cursor: 'pointer' }}
                            onClick={() => {navigate(`/feeds/contents/${row.id}`)}}
                        >
                            <TableCell 
                                align="left" 
                                sx={{ whiteSpace: 'nowrap' }}
                            >
                                {row.name}
                            </TableCell>
                            <TableCell align="center">
                                <Tooltip arrow title="Change Feed Status">
                                    <Switch
                                        size="small"
                                        checked={row.status === 'active'}
                                        onClick={(e) => {e.stopPropagation()}}
                                        onChange={(e) => {props.btnChangeStatus(row) }}
                                    />
                                </Tooltip>
                            </TableCell>
                            <TableCell align="center" timer={totalSeconds}>
                                { row.status === 'active' ? 
                                loadedTime(row.loaded_at || row.created_at)
                                : <Chip size="small" label="Never"/> }
                            </TableCell>
                            <TableCell >
                                { row.status === 'active' && row.ai_mode > 0 ? 
                                <LinearProgress variant="determinate" value={progressValue(row.processed)} />
                                : 'OFF' }
                            </TableCell>
                            <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                <Tooltip arrow title="Edit Feed">
                                    <IconButton onClick={(e) => {e.stopPropagation(); props.btnEditHandle(row) }}>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow title="Clone Feed">
                                    <IconButton onClick={(e) => {e.stopPropagation(); props.btnCloneHandle(row)}}>
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow title="Delete Feed">
                                    <IconButton onClick={(e) => {e.stopPropagation(); props.btnDeleteHandle(row) }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
